
import { Component, Vue, Watch } from 'vue-property-decorator'
import Objection from '@/types/objection'
import Customer from '@/types/customer'
import Building from '@/types/building'
import Project from '@/types/project'
import ServiceComments from '@/views/service/comments/ServiceComments.vue'
import ServiceCommentBlock from '@/views/service/comments/ServiceCommentBlock.vue'
import ServiceComment from '@/types/serviceComment'
import RelatedServiceItems from '@/views/service/RelatedServiceItems.vue'
import ActivityLogTable from '@/components/ActivityLogTable.vue'
import { ServiceClasses, ServiceStates, SortedStates, Status } from '@/types/serviceItem'
import Filelist from '@/components/media/Filelist.vue'
import ServiceObjectInfo from '@/views/service/ServiceObjectInfo.vue'
import ServiceDetails from '@/views/service/ServiceDetails.vue'
import ServiceContactInfo from '@/views/service/ServiceContactInfo.vue'
import ServiceBuildingSelector from '@/views/service/ServiceBuildingSelector.vue'
import axios from 'axios'
import SubscribeButton from '@/components/base/SubscribeButton.vue'
import SaveButton from '@/components/base/SaveButton.vue'
import PageHeader from '@/components/base/PageHeader.vue'
import PrioritySelector from '@/views/service/components/PrioritySelector.vue'
import ls from '@/ls'
import { can } from '@/globalFunctions'

@Component({
  methods: { can },
  components: {
    PrioritySelector,
    PageHeader,
    SaveButton,
    SubscribeButton,
    ServiceBuildingSelector,
    ServiceContactInfo,
    ServiceDetails,
    ServiceObjectInfo,
    Filelist,
    ActivityLogTable,
    RelatedServiceItems,
    ServiceCommentBlock,
    ServiceComments,
    ServiceCreateComment: ServiceComments
  }
})

export default class ObjectionEdit extends Vue {
  serviceClasses = ServiceClasses
  serviceStates = ServiceStates
  sortedStates = SortedStates
  config = {}

  @Watch('currentItem.project.id')
  onProjectChanged () : void {
    if (this.currentItem.project.id === 0) return
    this.$store.dispatch('getObjectionManagers', this.currentItem.project.id)
  }

  settings = {
    routeNames: { list: 'objections', show: 'objectionShow', edit: 'objectionEdit' },
    routeParamKey: 'objectionId',
    functionNames: { setCurrent: 'setCurrentObjection', save: 'saveObjection' },
    getterNames: { current: 'currentObjection', loading: 'loadingObjection', errors: 'objectionErrors' }
  }

  currentTab:string = ls.get('objectionEditActiveTab') || 'details'
  tabs = [
    {
      key: 'details',
      tab: 'Details'
    },
    {
      key: 'related',
      tab: 'Gerelateerd'
    },
    {
      key: 'activity',
      tab: 'Geschiedenis'
    }
  ]

  documentsGroups = []

  onTabChange (key:string): void {
    this.currentTab = key
  }

  mounted () : void {
    this.$store.dispatch(this.settings.functionNames.setCurrent, this.$route.params[this.settings.routeParamKey])
  }

  get customer () : Customer {
    return this.currentItem.building?.customer || new Customer()
  }

  get building () : Building {
    return this.currentItem.building || new Building()
  }

  get project () : Project {
    return this.currentItem.project || new Project()
  }

  get comments () : ServiceComment[] {
    return this.currentItem.comments || [new ServiceComment()]
  }

  get managers () : { id: number, active: boolean, full_name: string, role: string }[] {
    return this.$store.getters.objectionManagers
  }

  getStatus (): Status {
    return this.serviceClasses.find(s => s.id === this.currentItem.status) || this.serviceClasses[0]
  }

  filterOptions (input:string, option:{componentOptions:{children:{text:string}[]}}) : boolean {
    return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
  }

  getDocuments ():void {
    axios.get(`${process.env.VUE_APP_API_URL}/objections/documents/${this.currentItem.building_id}`)
      .then(res => {
        this.documentsGroups = res.data
      })
  }

  onBuildingSelected (id: number): void {
    this.getDocuments()
    this.$store.dispatch('setObjectionBuilding', id)
  }

  onProjectSelected (id: number): void {
    this.$store.dispatch('setObjectionProject', id)
  }

  onManagerSelected (id: number): void {
    this.$store.dispatch('setObjectionManager', id)
  }

  onCommentSaved (comment:ServiceComment): void {
    if (comment.waitingForResponse) {
      this.$store.dispatch('setObjectionStatus', this.serviceStates.InAfwachting)
    }
  }

  save () : void {
    this.$store.dispatch(this.settings.functionNames.save, this.currentItem)
  }

  saveAndReturn (): void {
    this.save()
    this.$router.push({ name: this.settings.routeNames.list })
  }

  get currentItem () : Objection {
    return this.$store.getters[this.settings.getterNames.current]
  }

  get loading () : boolean {
    return this.$store.getters[this.settings.getterNames.loading].item
  }

  get saving () : boolean {
    return this.$store.getters[this.settings.getterNames.loading].save
  }

  get errors () : { [key:string]: string[] } {
    return this.$store.getters[this.settings.getterNames.errors]
  }
}
